export default __webpack_public_path__ + "3019efe027a31abd33f10ba1db98139f.svg";